import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Icon } from 'components/atoms';
import { themeType } from 'types';

const defaultIcons = {
  open: 'chevron-left',
  closed: 'chevron-right',
};

const IconToggle = ({
  isActive, isOpen, icon, theme,
}) => {
  const [isHover, setIsHover] = useState(false);
  const [modifiers, setModifiers] = useState('');
  const [color, setColor] = useState(null);
  useEffect(() => {
    let modifiers = '';
    if (isHover) modifiers = 'inverse';
    if (isActive && !isHover) setColor(theme.colors.primary);
    else setColor(null);
    setModifiers(modifiers);
  }, [isHover, isActive, theme.colors.primary]);

  const iconName = useMemo(() => {
    const icons = { ...defaultIcons, ...icon };
    if (isOpen) return icons.open;
    return icons.closed;
  }, [isOpen, icon]);

  return (
    <Wrapper
      isActive={isActive}
      isHover={isHover}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Icon icon={iconName} color={color} height={18} modifiers={modifiers} />
    </Wrapper>
  );
};

IconToggle.propTypes = {
  isActive: PropTypes.bool,
  isOpen: PropTypes.bool,
  icon: PropTypes.shape({
    open: PropTypes.string,
    closed: PropTypes.string,
  }),
  theme: themeType.isRequired,
};

IconToggle.defaultProps = {
  isOpen: true,
  isActive: false,
  icon: defaultIcons,
};

const Wrapper = styled.button`
  background-color: ${({ theme, isHover }) => (isHover ? theme.colors.bgPrimary : theme.colors.bgLighter)};
  border: ${props => props.theme.values.borderSize} solid
    ${props => props.theme.colors.borderBtn};
  border-radius: 50%;
  height: ${props => props.theme.sizes.xl3};
  width: ${props => props.theme.sizes.xl3};
  box-shadow: ${props => props.theme.shadows.icon};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${props => props.theme.colors.bgPrimary};
  }
`;

export default withTheme(IconToggle);
